import axios from 'axios';
import authHeader from "@/service/auth-header";

class ClientSegmentService {

    async getCompanyClientSegments(companyId) {
        return await axios.get(`/api/clientsegment/${companyId}`, {headers: authHeader()})
    }

    async searchCompanyClientSegments(companyId, name) {
        return await axios.get(`/api/clientsegment/${companyId}/${name}`, {headers: authHeader()})
    }

    async getClientSegment(clientSegmentId) {
        return await axios.get(`/api/clientsegment/specific/${clientSegmentId}`, {headers: authHeader()})
    }

    async createClientSegment(companyId, data) {
        return await axios.post(`/api/clientsegment/${companyId}`, data, {headers: authHeader()});
    }

    async startClientSegment(companyId, data) {
        return await axios.post(`/api/clientsegment/start/${companyId}`, data, {headers: authHeader()});
    }

    async updateClientSegment(clientSegmentId, data) {
        return await axios.put(`/api/clientsegment/${clientSegmentId}`, data, {headers: authHeader()});
    }

    async deleteClientSegment(clientSegmentId) {
        return await axios.delete(`/api/clientsegment/${clientSegmentId}`, {headers: authHeader()})
    }
}

export default new ClientSegmentService();
